export default {
	popups: {},
	lastActive: null,
	freeCount: 0,
	add(id: string, popup: any) {
		if (this.lastActive) {
			this.popups[this.lastActive].classList.remove("dhx_popup--window_active");
		}
		this.lastActive = id;

		popup.classList.add("dhx_popup--window_active");
		this.popups[id] = popup;
	},
	setActive(id: string) {
		if (id === this.lastActive) {
			return;
		}
		const popup = this.popups[id];
		if (popup) {
			if (this.lastActive) {
				this.popups[this.lastActive].classList.remove("dhx_popup--window_active");
			}
			this.lastActive = id;
			popup.classList.add("dhx_popup--window_active");
		}
	},
	openFreeWindow(node: HTMLElement) {
		if (this.freeCount === 0) {
			node.classList.add("dhx_window--no-scroll");
		}
		this.freeCount++;
	},
	closeFreeWindow(node: HTMLElement) {
		this.freeCount--;
		if (this.freeCount === 0) {
			node.classList.remove("dhx_window--no-scroll");
		}
	},
};
